function devtricker_session_getNonce() {
    try {
        const nonceData = sessionStorage.getItem("devtricker_nonce");
        if (nonceData) {
            const nonceObject = JSON.parse(nonceData);
            const currentTime = new Date();
            const nonceTime = new Date(nonceObject.timestamp);

            if ((currentTime - nonceTime) < 3600 * 1000) {
                return nonceObject.nonce;
            } else {
                sessionStorage.removeItem("devtricker_nonce");
            }
        }
        return null;
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Error when trying to get the devtricker_nonce from sessionStorage');
        throw error;
    }
}

function devtricker_session_setNonce(nonce) {
    try {
        const nonceItem = {
            nonce: nonce,
            timestamp: new Date().toISOString()
        };
        sessionStorage.setItem("devtricker_nonce", JSON.stringify(nonceItem));
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Error when trying to save the new nonce in sessionStorage');
        throw error;
    }
}